import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import Card from '../components/CardDocuments';
import DocumentPagination from '../components/DocumentPagination';
import FilterComponent from '../components/FilterComponent';
import "../components/css/SignedDocuments.css";
import texts from '../constants/views/signedDocumentsText';
import documentosFirmadosNormal from "../img/navbar/documentosFirmadosNormal.svg";
import usePaginatedDocuments from '../hooks/usePaginatedDocuments';

const BASE_QUERY = "estadosDocumento=2&estadosFirma=2";

const SignedDocuments = ({ keycloak }) => {
    const [isEmailSectionVisible, setIsEmailSectionVisible] = useState(false);
    const {
        documents: filteredDocumentList,
        loading,
        noDocuments,
        errorMessageConnection,
        page,
        hasNextPage,
        pageSize,
        handleFilterResults,
        handlePageChange,
    } = usePaginatedDocuments({
        keycloak,
        endpoint: process.env.REACT_APP_GET_DOCS_INFO,
        baseQuery: BASE_QUERY,
        errorMessages: texts.errorMessages,
    });

    const handleToggleSection = () => {
        setIsEmailSectionVisible(!isEmailSectionVisible);
    };
    const isMobile = window.innerWidth < 900;
    return (
        <>
            {loading && (
                <Grid container justifyContent="center" alignItems="center">
                    <CircularProgress aria-busy="true"
                        aria-label="Cargando..." sx={{ color: "#316094" }} />
                </Grid>
            )}

            {!loading && noDocuments && !errorMessageConnection && (
                <Typography variant="body1" sx={{ margin: "auto", fontFamily: "robotoMedium", padding: "10px" }} gutterBottom>
                    {texts.noTieneDoc}
                </Typography>
            )}

            {!loading && !noDocuments && (
                <>
                    {isEmailSectionVisible ? (
                        <div className="blue-backgroundSignedDocuments">
                            <div className="rectangleSignedDocuments" aria-label="Sección de filtros para documentos">
                                <FilterComponent
                                    section="FIRMADO"
                                    keycloak={keycloak}
                                    baseQuery={BASE_QUERY}
                                    pageSize={pageSize}
                                    onFilter={handleFilterResults}
                                />
                            </div>
                        </div>
                    ) : null}
                    <div className="iconButtonContainerSigner">
                        <div className="color-bandSigner"></div>
                        <IconButton
                            onClick={handleToggleSection}
                            className="iconButtonSigner"
                            aria-label={isEmailSectionVisible ? "Cerrar sección de filtros" : "Abrir sección de filtros"}
                        >
                            {isEmailSectionVisible ? (
                                <ArrowBack sx={{ color: "white" }} />
                            ) : (
                                <ArrowForward sx={{ color: "white" }} />
                            )}
                        </IconButton>
                    </div>
                    {/* Contenedor para las tarjetas */}
                    <div className="scroll-containerSignedDocuments" role="region"
                        aria-label="Lista de documentos firmados" sx={{
                            justifyContent: isMobile
                                ? filteredDocumentList.length === 1
                                    ? 'flex-start !important'
                                    : 'center !important'
                                : null,
                        }}>
                        {isMobile ? (<div style={{ display: "flex", width: "90%", alignItems: "center" }}>
                            <img src={documentosFirmadosNormal} alt="" style={{ margin: '0px 10px 0px 0px' }} />
                            <Typography sx={{ width: "90%", textAlign: "left", color: "#316094", fontFamily: "robotoMedium" }}>{texts.title}</Typography>
                            <Typography
                                component="span"
                                aria-label={`Se muestran ${filteredDocumentList.length} documento${filteredDocumentList.length !== 1 ? "s" : ""} firmado${filteredDocumentList.length !== 1 ? "s" : ""} en la página ${page}.`}
                                className="visually-hidden"
                                aria-live="polite"
                            >
                                {`Se muestran ${filteredDocumentList.length} documento${filteredDocumentList.length !== 1 ? "s" : ""} firmado${filteredDocumentList.length !== 1 ? "s" : ""} en la página ${page}.`}
                            </Typography>
                        </div>) : <Typography
                            component="span"
                            aria-label={`Se muestran ${filteredDocumentList.length} documento${filteredDocumentList.length !== 1 ? "s" : ""} firmado${filteredDocumentList.length !== 1 ? "s" : ""} en la página ${page}.`}
                            className="visually-hidden"
                            aria-live="polite"
                        >
                            {`Se muestran ${filteredDocumentList.length} documento${filteredDocumentList.length !== 1 ? "s" : ""} firmado${filteredDocumentList.length !== 1 ? "s" : ""} en la página ${page}.`}
                        </Typography>}
                        <Grid container spacing={2} sx={{ backgroundColor: "#F0F0F2", width: "90%", padding: "16px", margin: "40px 0px" }}>
                            {filteredDocumentList.map((documentInfo) => (
                                <Grid item sx={{ padding: "0 !important", }} xs={12} sm={filteredDocumentList.length === 1 ? 12 : 6} key={documentInfo.id}>
                                    <div className="DivCardSignedDocuments">
                                        <Card keycloak={keycloak} documentInfo={documentInfo} section="FIRMADO" />
                                    </div>
                                </Grid>
                            ))}
                            {filteredDocumentList.length === 0 && !errorMessageConnection && (
                                <Typography variant="body1" sx={{ margin: "auto", fontFamily: "robotoMedium" }} gutterBottom role="alert"
                                    aria-live="assertive">
                                    {texts.errorMessages.noCoincidencia}
                                </Typography>
                            )}
                            {!loading && filteredDocumentList.length === 0 && errorMessageConnection && (
                                <Typography variant="body1" sx={{ margin: "auto", color: "red", fontFamily: "robotoMedium" }} gutterBottom role="alert"
                                    aria-live="assertive">
                                    {errorMessageConnection}
                                </Typography>
                            )}
                            <DocumentPagination
                                page={page}
                                hasNextPage={hasNextPage}
                                loading={loading}
                                onPageChange={handlePageChange}
                            />
                        </Grid>
                    </div>
                </>
            )}
        </>
    );
};


export default SignedDocuments;
